angular.module('wbComponents').directive 'customValidate', ['customValidation', (customValidation) ->
  restrict: 'A'
  require: 'ngModel'
  link: ($scope, $el, $attrs, ctrl) ->
    ctrl.$validators[$attrs.customValidate] = (model, view) ->
      value = model || view
      customValidation.isValid($attrs.customValidate, value)
]
